<template>
  <RetailNoOA />
</template>
<script>
import RetailNoOA from "@/components/RetailNoOA.vue";
export default {
  components: {
    RetailNoOA
  }
}
</script>